import { Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { Column } from '@miq/catalog';
import { columnNotFavoriteNotRequired } from './not-favorite-not-required';
import { VisibilityToggler } from './visibility-toggler';

@Directive({
  selector: '[miqShowFavoriteColumn]',
  standalone: false,
})
export class ShowFavoriteColumnDirective extends VisibilityToggler<Column> implements OnInit, OnChanges {
  @Input('miqShowFavoriteColumn') declare input: Column;

  constructor(protected el: ElementRef) {
    super(el);
  }

  shouldHide(favorites: { [key: number]: boolean }): boolean {
    return columnNotFavoriteNotRequired(favorites, this.input);
  }
}
